const STATUS = {
  MAPPED: "Mapped",
  UNMAPPED: "Unmapped",
};


const ACTION = {
  APPROVE: "Approve",
  REJECT: "Reject",
  UNDECIDED: "Undecided",
};

const HORIZONTAL_TABLE_ROW_HEIGHT = "64px";

export { STATUS, ACTION, HORIZONTAL_TABLE_ROW_HEIGHT };